import { createRouter, createWebHistory } from "vue-router";
import routes from "vue-auto-routing";
import { createRouterLayout } from "vue-router-layout";
import store from "@/store";
import { get } from "lodash";

const RouterLayout = createRouterLayout(layout => {
  return import("@/layouts/" + layout + ".vue");
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: RouterLayout,
      children: [
        ...routes,
        {
          path: "/convention/:id*",
          name: "convention",
          beforeEnter: async (to, from, next) => {
            let id = to.params.id;
            let codice = id.shift();
            await store.dispatch("setTrackers", { ...to.query, codice });
            next(id.reduce((acc, curr) => acc + "/" + curr, ""));
          }
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  if (get(to.meta, "disabledRoute")) {
    next({ path: "/" });
    return;
  }
  const scrolling = from.meta.order > to.meta.order ? "Up" : "Down";
  from.meta.scrolling = scrolling;
  to.meta.scrolling = scrolling;
  next();
});

router.afterEach(async to => {
  await store.dispatch("setTrackers", to.query);
});

export default router;
